import http from './http';
import dates from "../services/dates";
import {ENUMS} from "../services/enums";

export default {
  getAllFunnelCount(data) {
    return http().post(`/v1/stats/summary/funnel`, data);
  },
  getKPIStatRecords(stat, query) {
    return http().get(`/v1/stats/kpis/${stat}/records?${query}`);
  },
  getKPIStats(stats, data) {
    let requestData = {
      ...data,
      stats: stats
    };
    return http().post(`/v1/stats/kpis/query-stats`, requestData);
  },
  getFunnelStatRecords(stat, data) {
    return http().post(`/v1/stats/summary/funnel/${stat}`, data);
  },
  getFunnelCampaignStats(data) {
    return http().post(`/v1/stats/summary/funnel-campaigns`, data);
  },
  getLeadsAndDealsChart() {
    return http().get(`/v1/stats/leads-deals/chart`);
  },
  getLeadsAndDealsSummary() {
    return http().get(`/v1/stats/leads-deals/summary`);
  },
  getEmailStats(data) {
    return http().post(`/v1/stats_emails`, data);
  },
  getEmailStatsLog(data) {
    return http().post(`/v1/stats_emails/view_log`, data);
  },


  leadsPerMonthForLastYear(marketId) {
    return http().post(`/v1/stats/${marketId}/leads_per_month_for_last_year`);
  },
  dealsPerMonthForLastYear(marketId) {
    return http().post(`/v1/stats/${marketId}/deals_per_month_for_last_year`);
  },
  dealsFromFollowUpPerMonthForLastYear(marketId) {
    return http().post(`/v1/stats/${marketId}/deals_from_follow_up_per_month_for_last_year`);
  },
  dealsNotFromFollowUpPerMonthForLastYear(marketId) {
    return http().post(`/v1/stats/${marketId}/deals_not_from_follow_up_per_month_for_last_year`);
  },




  getCampaignSpendStatBox(marketId, statsTimeFrame) {
    return http().post(`/v1/stats/${marketId}/stat_box/campaign_spend`, statsTimeFrame);
  },
  getCampaignUnitsStatBox(marketId, statsTimeFrame) {
    return http().post(`/v1/stats/${marketId}/stat_box/campaign_units`, statsTimeFrame);
  },
  getQualifiedLeadsGeneratedStatBox(marketId, statsTimeFrame) {
    return http().post(`/v1/stats/${marketId}/stat_box/qualified_leads_generated`, statsTimeFrame);
  },
  getCostPerQualifiedLeadStatBox(marketId, statsTimeFrame) {
    return http().post(`/v1/stats/${marketId}/stat_box/cost_per_qualified_lead`, statsTimeFrame);
  },


  getAppointmentsStatBox(marketId, statsTimeFrame) {
    return http().post(`/v1/stats/${marketId}/stat_box/appointments`, statsTimeFrame);
  },
  getBuyingOffersStatBox(marketId, statsTimeFrame) {
    return http().post(`/v1/stats/${marketId}/stat_box/buying_offers`, statsTimeFrame);
  },
  getBuyingContractsStatBox(marketId, statsTimeFrame) {
    return http().post(`/v1/stats/${marketId}/stat_box/buying_contracts`, statsTimeFrame);
  },
  getBuyingClosingsStatBox(marketId, statsTimeFrame) {
    return http().post(`/v1/stats/${marketId}/stat_box/buying_closings`, statsTimeFrame);
  },
  getDealsStatBox(marketId, statsTimeFrame) {
    return http().post(`/v1/stats/${marketId}/stat_box/deals`, statsTimeFrame);
  },
  getLeadToDealConversionStatBox(marketId, statsTimeFrame) {
    return http().post(`/v1/stats/${marketId}/stat_box/leads_to_deal_conversion`, statsTimeFrame);
  },
  getDealsFromFollowUpStatBox(marketId, statsTimeFrame) {
    return http().post(`/v1/stats/${marketId}/stat_box/deals_from_follow_up`, statsTimeFrame);
  },
  getCompletedDealsStatBox(marketId, statsTimeFrame) {
    return http().post(`/v1/stats/${marketId}/stat_box/completed_deals`, statsTimeFrame);
  },
  getActualProfitStatBox(marketId, statsTimeFrame) {
    return http().post(`/v1/stats/${marketId}/stat_box/actual_profit`, statsTimeFrame);
  },



  getActiveDealsPaginatedData(marketId, statsTimeFrame, queryString) {
    return http().post(`/v1/stats/${marketId}/list/active_deals?${queryString}`, statsTimeFrame);
  },
  getCompletedDealsPaginatedData(marketId, statsTimeFrame, queryString) {
    return http().post(`/v1/stats/${marketId}/list/completed_deals?${queryString}`, statsTimeFrame);
  },
  getAccountabilityData(marketId, statsTimeFrame) {
    return http().post(`/v1/stats/${marketId}/list/accountability`, statsTimeFrame);
  },


  getStatsCampaignChart(statsTimeFrame) {
    return http().post(`/v1/stats/campaigns/chart`, statsTimeFrame)
  },
  getStatsCampaignLeadChart(statsTimeFrame) {
    return http().post(`/v1/stats/campaigns/lead-chart`, statsTimeFrame)
  },
  getStatsCampaignContractedChart(statsTimeFrame) {
    return http().post(`/v1/stats/campaigns/contracted-chart`, statsTimeFrame)
  },
  getStatsCampaignClosedChart(statsTimeFrame) {
    return http().post(`/v1/stats/campaigns/closed-chart`, statsTimeFrame)
  },
  getStatsCampaignSummary(data) {
    return http().post(`/v1/stats/campaigns/summary`, data)
  },
}
